export const SharedFeatureToggleIds = {
  ENABLE_PACKAGE_RESTRUCTURE: 'G-maDF-nSj20lMUzzAZKag',
};
